import React, { useContext, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { getImages } from '../../const';
import { UserContext } from '../../Context/UserContext';

const AdminHeader = () => {
    
    
    const { user, logout } = useContext(UserContext)
    const [isMob, setisMob] = useState(false);
    const onChangeBodyClass = (value) => {
        setisMob(value);
        value
            ? document.body.classList.add('overflow-active')
            : document.body.removeAttribute('class');
    };
  return (
    <>
    <header className="admin-header-wrap">
        <div className="container-fluid">
            <div className="admin-header-block d-flex align-items-center">
                <div className="admin-header-left">
                    <Link to="/" className="admin-main-logo">
                        <img src={getImages('mclaren-orlando-logo-white.png')} alt='mclaren logo' />
                    </Link>
                </div>
                <div className="admin-header-right d-flex align-items-center justify-content-between menu-block">
                    <div className={`d-flex w-100 align-items-center justify-content-between menus-for-mobile ${isMob ? 'active' : ''}`}>
                        <div className="admin-main-menu">
                            <ul>
                                <li>
                                    <Link to="/admin/dashboard">Dashboard</Link>
                                </li>
                                <li>
                                    <Link to="/admin/featured-vehicles">Featured Vehicles</Link>
                                </li>
                                <li>
                                    <Link to="/admin/dashboard">Specials</Link>
                                </li>
                            </ul>
                        </div>
                        <div className="login-block ms-auto">
                            <div className="btn-group admin-custom-dropdown ms-3">
                                <button type="button" className="btn btn-secondary dropdown-toggle text-green" data-bs-toggle="dropdown" aria-expanded="false">
                                    <img src={getImages('icon-user.svg')} className='me-4' /> {user.first_name} {user.last_name}
                                </button>
                                <div className="dropdown-menu dropdown-menu-end">
                                    <button className="dropdown-item" type="button" 
                                        onClick={() => logout()}
                                    >Logout</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`overflow-bg d-none ${isMob ? 'active' : ''
                        }`}
                        onClick={() => onChangeBodyClass(!isMob)}
                    ></div>
                    <div className={`mobile-inner-header ${isMob ? 'active' : ''}`}
                        onClick={() => onChangeBodyClass(!isMob)}>
                        <div className={`mobile-inner-header-icon mobile-inner-header-icon-out ${isMob ? 'active' : ''
                            }`}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
    </>
  )
}

export default AdminHeader